import { z } from 'zod';

export const rawMaterialFormSchema = z.object({
  name: z.string()
    .min(1, 'El nombre es requerido')
    .max(255, 'El nombre debe tener máximo 255 caracteres'),
  code: z.string()
    .max(100, 'El código debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  category: z.string({
    required_error: 'La categoría es requerida',
  }).min(1, 'La categoría es requerida'),
  supplier: z.string()
    .max(255, 'El proveedor debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  batch_number: z.string()
    .max(100, 'El número de lote debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  roll_number: z.string()
    .max(100, 'El número de rollo debe tener máximo 100 caracteres')
    .optional()
    .or(z.literal('')),
  quantity: z.number()
    .min(0.001, 'La cantidad debe ser mayor a 0'),
  roll_count: z.number()
    .int('La cantidad de rollos debe ser un número entero')
    .min(0, 'La cantidad de rollos debe ser mayor o igual a 0')
    .optional(),
  unit: z.enum(['m2', 'L', 'garrafa', 'galon', 'caja', 'paquete', 'kg', 'otro'], {
    required_error: 'La unidad es requerida',
  }).default('kg'),
  custom_unit: z.string()
    .max(50, 'La unidad personalizada debe tener máximo 50 caracteres')
    .optional()
    .or(z.literal('')),
  square_meters: z.number().min(0).optional(),
  production_date: z.string()
    .optional()
    .or(z.literal('')),
  purchase_date: z.string()
    .optional()
    .or(z.literal('')),
  expiry_date: z.string()
    .optional()
    .or(z.literal('')),
  cost_per_unit: z.number()
    .min(0, 'El costo por unidad debe ser mayor o igual a 0')
    .optional(),
  location: z.string()
    .max(255, 'La ubicación debe tener máximo 255 caracteres')
    .optional()
    .or(z.literal('')),
  notes: z.string()
    .max(2000, 'Las notas deben tener máximo 2000 caracteres')
    .optional()
    .or(z.literal('')),
  is_freezer_material: z.boolean().default(false),
  is_active: z.boolean().default(true),
});

export type RawMaterialFormData = z.infer<typeof rawMaterialFormSchema>;
